<template>
  <div class="ai-detail-dialog">
    <el-dialog v-model="detailVisible" class="ai-detail-dialog-style" :show-close="false">
      <template #header>
        <DetailDialogHeader
          ref="headerRef"
          v-model:activ-mode="activMode"
          :deatil-data="deatilData"
          :detail-type="detailType"
          :inxbb="inxbb"
          :sale-order-process-permission="saleOrderProcessPermission"
          :show-name="showName"
          :title-desc="titleDesc"
          @changeMode="handleChangeMode"
          @linkLark="handleLinkLark"
        />
        <i class="dialog-close icon-close-large-line t-iconfont" @click="detailVisible = false"></i>
        <el-tooltip
          v-if="headerHeight && activMode === 'followupDiagnosis' && activeStageId"
          class="box-item"
          :content="isExpand ? '收起阶段拜访轨迹' : '展开阶段拜访轨迹'"
          effect="dark"
          placement="top"
        >
          <div
            class="expand-box"
            :style="{
              top: isExpand ? `${rootLineHeight + headerHeight - 8}px` : `${headerHeight - 8}px`
            }"
            @click="isExpand = !isExpand"
          >
            <i
              class="icon-arrow-up-s-fill t-iconfont"
              :style="{ transform: isExpand ? 'rotate(0deg)' : 'rotate(180deg)' }"
            ></i>
          </div>
        </el-tooltip>
      </template>
      <div v-if="isInit" class="ai-detail__box">
        <template v-if="!activeStageId && activMode === 'followupDiagnosis'">
          <div class="ai-detail__empty">
            <Empty :title="emptyTitle" />
          </div>
        </template>
        <template v-else>
          <div
            v-loading="visitLoading"
            class="root-line"
            :style="{ height: isExpand ? '152px' : '0px' }"
          >
            <VisitPath
              v-if="!visitLoading"
              v-model:active-stage-id="activeStageId"
              :behaving-stage-list="behavingStageList"
              @activeStageChange="handleActiveStageChange"
              @activeStageIdChange="handleActiveStageIdChange"
            ></VisitPath>
          </div>
          <template v-if="activMode === 'followupDiagnosis'">
            <div v-loading="followLoading" class="tab-box">
              <div class="tab-box__left">
                <TabNormal
                  v-if="activeStage.kind !== 2"
                  v-model:value="activeLeft"
                  :options="leftTabs"
                  @change="handleChangeLeftTab"
                />
                <DetailDialogLeft
                  ref="leftRef"
                  :active-stage="activeStage"
                  :behaving-id="activeStageId"
                  :chat-list="chatList"
                  :communicate-contents="communicateContents"
                  :detail-type="detailType"
                  :is-liberal-rules="isLiberalRules"
                  :meeting-duration="meetingDuration"
                  :minutes-id="minutesId"
                  :opportunity="opportunity"
                  :session-archive-params="sessionArchiveParams"
                  :source-type="sourceType"
                  :url="url"
                  :useless-tittle="uselessTittle"
                  :wx-params="wxParams"
                  :yk-type="ykType"
                  :yk-wechat-config="ykWechatConfig"
                  @openUrl="handleOpenUrl"
                />
              </div>
              <div class="tab-box__right">
                <TabSlide v-model:value="activeName" :options="tabs" />
                <div
                  class="detail-content"
                  :style="{
                    justifyContent:
                      activeName === 'suggestion' && isActionStrategyConfigEnable
                        ? 'space-around'
                        : 'flex-start'
                  }"
                >
                  <template v-if="activeName === 'quality'">
                    <AiDetailAnalysis
                      v-if="riskResult"
                      :behaving-id="activeStageId"
                      :quality-analysis-info="qualityAnalysisInfo"
                      :suggestion="suggestion"
                      :yk-type="ykType"
                      @handleClickTime="handleClickTime"
                      @handleRefresh="handleRefresh"
                    ></AiDetailAnalysis>
                  </template>
                  <template v-else-if="activeName === 'suggestion'">
                    <div v-if="isActionStrategyConfigEnable" class="unenableSuggest">
                      <img alt="AI助手logo" src="@/assets/chatbot.svg" />
                      <span>当前跟进未启用本项分析</span>
                    </div>
                    <template v-else>
                      <Empty v-if="+activeStage.kind === 2" :empty-text="uselessTittle" />
                      <NextStepCard
                        v-else
                        :ai-recommend-plan="aiRecommendPlan"
                        :attributes="aiMeetingExecuteStrategy"
                        in-detail
                        :recommend-task-enable="recommendTaskEnable"
                        @removeData="removeData"
                      />
                    </template>
                  </template>
                  <template v-else-if="activeName === 'employee'">
                    <Empty v-if="+activeStage.kind === 2" :empty-text="uselessTittle" />
                    <EmployeePerformance
                      v-else
                      :active-stage="activeStage"
                      :data-info="employeeBehaviorInfo"
                      :has-enable-rule="hasEnableRule"
                      :status="analyzingStatus"
                    ></EmployeePerformance>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="activMode === 'orderAnalysis'">
            <div v-loading="orderLoading" class="tab-box">
              <OrderAnalysis
                v-if="!orderLoading"
                :deatil-data="deatilData"
                :detail-type="detailType"
                :sale-order-data="saleOrderData"
                @refresh="handleSuccess"
                @success="handleSuccess"
              ></OrderAnalysis>
            </div>
          </template>
        </template>
      </div>
    </el-dialog>
    <LinkLarkDialog
      ref="linkLarkRef"
      v-model="linkLarkVisible"
      :lark-group-params="larkGroupParams"
      @createGroupChat="handleCreateGroupChat"
      @linkExistingGroupChat="handleLinkExistingGroupChat"
    />
    <NewLarkDialog
      v-model="newLarkVisible"
      :business-type="larkGroupParams.businessType"
      :data-id="larkGroupParams.dataId"
      :member-list="larkGroupUserList"
      :show-name="showName"
      @success="handleAddLarkGroupSuccess"
    />
    <LinkExisitingLarkDialog
      v-model="linkExisitingLarkVisible"
      :business-type="larkGroupParams.businessType"
      :data-id="larkGroupParams.dataId"
      @help="handleHelpClick"
      @success="handleAddLarkGroupSuccess"
    />
    <HowToGetCodeDialog v-model="howToGetCodeVisible" />
  </div>
</template>

<script setup>
import VisitPath from '../visit-path.vue'

import {
  getBehavingReviewDetail,
  getBehavingReviewDetailOpportunity,
  getBehavingDetail,
  getClueBehavingReviewDetail,
  getSessionArchiveParams,
  getWechatUrlApi
} from '@/api/ai-board'

import { getResult, getOrderAnalysisPermission } from '@/api/ai-detail.js'
// import { mapMutations } from 'vuex'
import EmployeePerformance from '@/pages/ai-board/employee-performance/index.vue'
import AiDetailAnalysis from '../ai-detail-analysis.vue'
import NextStepCard from '@/components/Cards/RelaVisitorCard.vue'
import { ref, onMounted, computed, provide } from 'vue'
import xbbSdk from 'xbb-sdk'
import xbb from '@xbb/xbb-utils'
import TabNormal from './tab-noraml.vue'
import DetailDialogHeader from './components/detail-dialog-header.vue'
import DetailDialogLeft from './components/detail-dialog-left.vue'
import TabSlide from './components/tab-slide.vue'
import utils from '@/utils'
import { useSystemSetStore } from '@/store/systemSet'
import OrderAnalysis from './components/order-analysis.vue'
import Empty from '@/components/Empty/index.vue'
import LinkLarkDialog from './components/link-lark-dialog.vue'
import NewLarkDialog from './components/new-lark-dialog.vue'
import LinkExisitingLarkDialog from './components/link-exisiting-lark.vue'
import HowToGetCodeDialog from './components/how-to-getcode-dialog.vue'

defineOptions({
  name: 'AiDetailDialog'
})
const props = defineProps({
  showDetail: {
    type: Boolean,
    default: false
  },
  deatilData: {
    type: Object,
    default: () => ({})
  },
  detailType: {
    type: String,
    default: 'customer'
  },
  emptyTitle: {
    type: String,
    default: '暂无数据'
  },
  isDefaultTab: {
    // 是否默认tab （跟进诊断/打单分析），默认为跟进诊断
    type: Boolean,
    default: false
  }
})

const businessEnum = {
  opportunity: {
    api: getBehavingReviewDetailOpportunity,
    businessType: 301,
    idKey: 'opportunityId',
    nameKey: 'opportunityName'
  },
  customer: {
    api: getBehavingReviewDetail,
    businessType: 100,
    idKey: 'customerId',
    nameKey: 'customerName'
  },
  clue: {
    api: getClueBehavingReviewDetail,
    businessType: 8000,
    idKey: 'clueId',
    nameKey: 'clueName'
  }
}

const emits = defineEmits(['update:showDetail'])

const opportunity = ref({})
const titleDesc = ref([])
const showName = ref('')
const isExpand = ref(false)
const headerRef = ref(null)
const headerHeight = ref(0)
const rootLineHeight = ref(152)
const activeLeft = ref('followup')
const leftTabs = ref([
  {
    label: '跟进内容',
    value: 'followup'
  }
])

const activeStageId = ref(1)
const activeStage = ref({})
const riskStatus = ref(0)
const isInit = ref(false)
const followLoading = ref(true)
const orderLoading = ref(true)
const behavingStageList = ref([])
const chatList = ref([])
const communicateContents = ref('')
const analyzingStatus = ref('')
const isLiberalRules = ref(0) // 0 老规则 1 新规则
const meetingDuration = ref('')
const suggestion = ref('')
const evidence = ref([])
const url = ref('')
const activeName = ref('quality')
const riskResult = ref('')
// 质量分析信息
const qualityAnalysisInfo = ref({})
provide('evidence', evidence)
// 拜访轨迹加载状态
const visitLoading = ref(false)
const tabs = ref([])
// 行动建议数据
const aiMeetingExecuteStrategy = ref(null)
// 会话存档请求参数
const sessionArchiveParams = ref({})
const leftRef = ref(null)
//
const minutesId = ref('')
// 云客手机类型 ykMobile 云客电话, ykWechat 微信聊天
const ykType = ref('')
// 来源类型
// 1: 跟进助手,2: 跟进记录（CRM）,3: 呼叫中心-销帮帮
// ykType = ykWechat 时， 6：微信单聊，11：微信群聊，
const sourceType = ref(undefined)
// 微信好友参数
const wxParams = ref('')
const activMode = ref('followupDiagnosis')
const saleOrderProcessPermission = ref(false) // 销售订单分析权限
const saleOrderData = ref({}) // 销售订单分析数据

// ai推荐任务
const aiRecommendPlan = ref([])
const recommendTaskEnable = ref(false)
// 是否未开启任何行动策略配置
const isActionStrategyConfigEnable = computed(() => {
  return !systemStore.linkCommunicatePlanEnable && !systemStore.recommendTaskEnable
})

const hasEnableRule = computed(() => {
  return systemStore.hasEnableRule
})

const uselessTittle = computed(() => {
  return qualityAnalysisInfo.value.staffRiskResult || qualityAnalysisInfo.value.riskResult
})

const inxbb = ref(false)
const systemStore = useSystemSetStore()

const detailVisible = computed({
  get() {
    return props.showDetail
  },
  set(val) {
    emits('update:showDetail', val)
  }
})

// 员工表现分析
const employeeBehaviorInfo = ref({})
const linkLarkVisible = ref(false)
const newLarkVisible = ref(false)
const linkExisitingLarkVisible = ref(false)
const howToGetCodeVisible = ref(false)
const larkGroupUserList = ref([])
const linkLarkRef = ref(null)
const larkGroupParams = computed(() => {
  const paramsMap = {
    customer: {
      dataId: props.deatilData.customerId,
      businessType: 100
    },
    opportunity: {
      dataId: props.deatilData.opportunityId,
      businessType: 301
    }
  }
  return paramsMap[props.detailType] || {}
})

const handleLinkLark = () => {
  linkLarkVisible.value = true
}

const handleCreateGroupChat = (userList = []) => {
  larkGroupUserList.value = userList
  newLarkVisible.value = true
}

const handleAddLarkGroupSuccess = () => {
  linkLarkRef.value?.refresh()
}

const handleLinkExistingGroupChat = () => {
  linkExisitingLarkVisible.value = true
}

const handleHelpClick = () => {
  howToGetCodeVisible.value = true
}

const handleChangeMode = (val) => {
  if (val === 'orderAnalysis') {
    orderLoading.value = true
    handleOrderRefresh()
    isExpand.value = false
  } else if (val === 'followupDiagnosis') {
    isExpand.value = true
    getTopHeight()
  }
}

const removeData = (index) => {
  aiRecommendPlan.value.splice(index, 1)
}

// 刷新页面信息
const handleRefresh = () => {
  getTheBehavingReviewDetail()
}

const handleOrderRefresh = async () => {
  const businessInstant = businessEnum[props.detailType]
  const params = {}
  params[businessInstant.idKey] = props.deatilData[businessInstant.idKey]
  if (props.detailType === 'clue' && !props.deatilData.clueId) {
    params.clueId = props.deatilData.customerId
  }
  try {
    const res = await getResult(params)
    saleOrderData.value = res.result
  } catch (error) {
    console.error('获取分析结果失败:', error)
  }
  orderLoading.value = false
  // orderLoading.value = true
  // setTimeout(() => {
  //   orderLoading.value = false
  // }, 5000)
}

const handleSuccess = () => {
  handleOrderRefresh()
}

const handleClickTime = (seconds, item) => {
  leftRef.value.handleClickTime(seconds, item)
}

const handleChangeLeftTab = (val) => {
  const classname = `${val}-title`
  const title = document.querySelector(`.${classname}`)
  if (title) {
    title.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}

/**
 * 初始化tab
 */
const initTab = (val) => {
  leftTabs.value = [
    {
      label: '跟进内容',
      value: 'followup'
    }
  ]
  // activeLeft.value = leftTabs.value[0].value
  if (chatList.value.length && ykType.value !== 'ykWechat') {
    leftTabs.value.push({
      label: '会话原文',
      value: 'session'
    })
  } else if (ykType.value === 'ykWechat') {
    const label = val?.sourceType === 11 ? '微信群聊' : '微信单聊'
    leftTabs.value.push({
      // label: '聊天记录',
      label,
      value: 'wechat-session'
    })
  }
  const allTabs = [
    { name: '质量分析', key: 'quality', icon: 'icon-ai-generate-2' },
    { name: '员工表现', key: 'employee', icon: 'icon-bookmark-3-line', isBeta: false },
    { name: '行动建议', key: 'suggestion', icon: 'icon-flag-line' }
  ]
  let filteredTabs = allTabs.filter((item) => {
    if (
      item.key === 'suggestion' &&
      !systemStore.linkCommunicatePlanEnable &&
      !systemStore.recommendTaskEnable
    ) {
      return false
    }
    // 过滤员工表现
    return !(item.key === 'employee' && !systemStore.isEmployeePerform)
  })
  // 1: 跟进助手,2: 跟进记录（CRM）,3: 呼叫中心-销帮帮
  // 如果sourceType为2时，tabs则只显示质量分析和，跟进内容，行动建议，否则全部展示
  if (val?.sourceType === 2) {
    filteredTabs = filteredTabs.filter((item) => ['quality', 'suggestion'].includes(item.key))
  }
  // 最终赋值
  tabs.value = filteredTabs
}

const handleOpenUrl = (url) => {
  if (inxbb.value) {
    xbbSdk.sendMessage('xbbPreview', url)
  } else {
    window.open(url, '_blank')
  }
}

const handleActiveStageChange = (item) => {
  activeStage.value = item
}

// 云客微信会话组件参数
const ykWechatConfig = ref({})

const getYkWechatConfig = async (behavingId, sourceType) => {
  const res = await getWechatUrlApi({
    behavingId
  })
  ykWechatConfig.value = res.result
}
const handleActiveStageIdChange = (id, manual = false) => {
  activeLeft.value = 'followup'
  chatList.value = []
  opportunity.value = {}
  communicateContents.value = ''
  analyzingStatus.value = ''
  isLiberalRules.value = 0
  meetingDuration.value = ''
  suggestion.value = ''
  evidence.value = []
  url.value = ''
  riskResult.value = ''
  ykType.value = ''
  sourceType.value = undefined
  wxParams.value = ''
  ykWechatConfig.value = {}
  followLoading.value = true
  activeName.value = 'quality'
  aiMeetingExecuteStrategy.value = null
  getBehavingDetail({
    behavingId: id
  })
    .then((res) => {
      // 拿到参数后立即判断获取云客对话历史记录
      // 6 单聊聊天
      // 11 群聊
      if (res.result.ykType === 'ykWechat' && [6, 11].includes(res.result.sourceType)) {
        getYkWechatConfig(id, res.result.sourceType)
      }
      // 下面所有的赋值内容 都要在 请求之前 初始化。因为直接在原页面上切换渲染数据
      communicateContents.value = res.result.communicateContents
      analyzingStatus.value = res.result.analyzingForEmployeePerformance
      isLiberalRules.value = res.result.isLiberalRules
      if (res.result.opportunity) {
        opportunity.value = res.result.opportunity
        opportunity.value.id = props.deatilData.id
      }
      chatList.value = res.result.aiAudioTopicAnalyseList || []
      ykType.value = res.result.ykType
      sourceType.value = res.result.sourceType
      if (res.result.ykType) {
        wxParams.value = xbb._get(res, 'result.param', {})
      }
      meetingDuration.value = res.result.meetingDuration
      suggestion.value = res.result.suggestion
      // evidence 标签
      evidence.value = res.result.evidence || []
      url.value = res.result.url
      employeeBehaviorInfo.value = { taskId: id, ...res.result?.employeeBehavior } || {}
      recommendTaskEnable.value = res.result.recommendTaskEnable === 1
      aiRecommendPlan.value = res.result.taskList || []
      riskResult.value = res.result.riskResult
      riskStatus.value = res.result.riskStatus
      qualityAnalysisInfo.value = res.result
      minutesId.value = res.result.minutesId

      // saleOrderProcessPermission.value = res.result.saleOrderProcessPermission || false
      // if (!manual && !props.isDefaultTab) {
      //   if (saleOrderProcessPermission.value) {
      //     activMode.value = 'orderAnalysis'
      //   } else {
      //     activMode.value = 'followupDiagnosis'
      //   }
      // }
      initTab(res.result)
      // 如果是企微公司则走此逻辑
      const paltFormType = utils.getPlatform(utils.xbbLocalStorageGet('corpid'))
      if (paltFormType === 'wx') {
        toGetSessionArchiveParams(id)
      }
      try {
        aiMeetingExecuteStrategy.value = {
          linkCommunicatePlanEnable: res.result.linkCommunicatePlanEnable,
          refiningCommunicatePlanEnable: res.result.refiningCommunicatePlanEnable,
          ...JSON.parse(res.result.aiMeetingExecuteStrategy || '{}')
        }
      } catch (error) {}
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      followLoading.value = false
      isInit.value = true
      if (activMode.value === 'followupDiagnosis') {
        // 跟进诊断模式 需要展开收起阶段拜访轨迹
        isExpand.value = true
        getTopHeight()
      }
    })
}

// 获取企微参数
const toGetSessionArchiveParams = (behavingId) => {
  sessionArchiveParams.value = {}
  // 获取会话存档参数
  getSessionArchiveParams({
    behavingId
  }).then((res) => {
    const sessionParam = res.result.param || {}
    const diffSourceParams = {}
    let hasTab = false
    if (sessionParam.externalUserId) {
      diffSourceParams.externalUserId = sessionParam.externalUserId
      hasTab = true
    } else if (sessionParam.chatId) {
      diffSourceParams.chatId = sessionParam.chatId
      hasTab = true
    }
    sessionArchiveParams.value = {
      ...diffSourceParams,
      // externalUserId: sessionParam.externalUserId,
      from: sessionParam.from,
      sessionUserId: sessionParam.sessionUserId,
      sessionType: sessionParam.sessionType,
      msgType: 'all',
      // remark
      remark: sessionParam.remark,
      chatName: sessionParam.chatName
    }
    // 补充一个tab
    hasTab &&
      leftTabs.value.push({
        label: '会话聊天记录',
        value: 'session-archive'
      })
  })
}

const environmentInit = () => {
  // 获取完整 URL 中的搜索参数部分（即 "?inxbb=1"）
  const searchParams = new URLSearchParams(window.location.search)
  // 通过参数名 "inxbb" 获取对应的值
  const inxbbValue = searchParams.get('inxbb') || ''
  inxbb.value = +inxbbValue === 1
}

const getTopHeight = () => {
  if (!headerHeight.value) {
    headerHeight.value = headerRef.value.$el.clientHeight + 32
  }
}

const getTheBehavingReviewDetail = () => {
  visitLoading.value = true
  const detailType = props.detailType
  const businessInstant = businessEnum[detailType]
  const params = {
    behavingId: activeStageId.value
  }

  params[businessInstant.idKey] = props.deatilData[businessInstant.idKey]

  if (props.detailType === 'clue' && !props.deatilData.clueId) {
    params.clueId = props.deatilData.customerId
  }
  businessInstant
    .api(params)
    .then((res) => {
      showName.value = res.result[businessInstant.nameKey]
      titleDesc.value = res.result.title
      behavingStageList.value = res.result.behavingStageList.map((item) => {
        return {
          name: item.stageName,
          len: item.sessionCount,
          time: item.timeUse,
          items: item.communicateBehavingList
            ? item?.communicateBehavingList?.map((session) => {
                return {
                  id: session.behavingId,
                  name: session.customerName,
                  recordtime: session.communicateDuration,
                  type: session.communicateType,
                  sessionCreatorName: session.sessionCreatorName,
                  time: session.communicateTime,
                  kind: session.isRisk,
                  sourceType: session.sourceType
                }
              })
            : []
        }
      })
      if (activeStageId.value) {
        handleActiveStageIdChange(activeStageId.value)
      } else {
        followLoading.value = false
        isInit.value = true
      }
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      visitLoading.value = false
      isInit.value = true
    })
}

const getOrderAnalysisPermissionInfo = () => {
  const businessType = businessEnum[props.detailType]?.businessType

  businessType &&
    getOrderAnalysisPermission({
      businessType
    }).then((res) => {
      saleOrderProcessPermission.value = res.result.saleOrderProcessPermission || false
      if (!props.isDefaultTab) {
        if (saleOrderProcessPermission.value) {
          activMode.value = 'orderAnalysis'
        } else {
          activMode.value = 'followupDiagnosis'
        }
      } else {
        !props.deatilData.id && (activMode.value = 'orderAnalysis')
      }
    })
}
onMounted(async () => {
  await systemStore.getIsActionAdvice()
  await systemStore.getIsEmployeePerform()
  environmentInit()
  activeStageId.value = props.deatilData.id
  handleRefresh()
  handleOrderRefresh()
  getOrderAnalysisPermissionInfo()
})
</script>

<style lang="scss" scoped>
.ai-detail-dialog {
  font-family: PingFang SC;
  .ai-detail-dialog-style {
    overflow: hidden;
  }
  :deep(.ai-detail-dialog-style) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: unset;
    & > .el-dialog__header {
      display: flex;
      padding: 16px 24px;
      background-color: #ffffff;
      border-bottom: unset;
      .dialog-close {
        height: 30px;
        width: 30px;
        cursor: pointer;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 16px;
      }
      .dialog-close:hover {
        background: #f2f3f5;
      }

      .expand-box {
        cursor: pointer;
        width: 40px;
        height: 16px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #e5e6eb;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: calc(50% - 20px);
        z-index: 1;
      }
    }
    & > .el-dialog__body {
      flex: 1;
      padding: 0;
      overflow: hidden;
      position: relative;
    }
    .el-dialog__body::-webkit-scrollbar {
      width: 6px;
      height: 10px;
      background: transparent;
    }
    .el-tabs__item.is-active {
      font-weight: 600;
      color: #323233 !important;
    }
  }
  .ai-detail__box {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    background: #f2f3f5;
    .ai-detail__empty {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .root-line {
      position: relative;
      flex: 0 0 auto;
      padding: 0 24px;
      background: #ffffff;
      margin-bottom: 16px;
      height: 152px;
      overflow: hidden;
      transition: height 0.3s ease;
    }
    .tab-box {
      flex: 1;
      display: flex;
      position: relative;
      overflow: hidden;
      padding: 0 12px 12px 12px;
      .tab-box__left {
        flex: 1;
        position: relative;
        margin-right: 12px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .tab-box__right {
        position: relative;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 8px;
        padding-top: 16px;
        .tab-slide {
          margin-left: 16px;
        }

        .detail-content {
          flex: 1;
          padding: 0 16px 16px 16px;
          margin-top: 16px;
          overflow: auto;
          line-height: 20px;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
.unenableSuggest {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 50px 0;
  font-size: 14px;
  font-family: PingFang SC;
  color: #969799;
}
</style>

<style lang="scss">
.ai-detail-dialog-style {
  margin: 0 !important;
}
</style>
